import React, { Component } from "react";
import * as firebase from "firebase";
import "./PrintGiftCards.css";

let QRCode = require("qrcode.react");

// 실물 상품권 인쇄 페이지.
// /print_gift_cards?ids=아이디1,아이디2 로 열리며, 브라우저 인쇄(PDF로 저장)로 출력한다.
// 카드 디자인은 손님이 보는 상품권 페이지(GiftCard.js)와 같다.
//  - A4 모드: 한 장에 카드 10장(2열 5행). 양면 선택 시 앞면 시트 다음에 뒷면 시트가 오고,
//    뒷면은 양면 인쇄(긴 쪽 뒤집기)에서 앞면과 맞도록 각 줄의 좌우를 바꿔 배치한다.
//  - 카드 모드(인쇄업체용): 카드 1장 = PDF 1페이지(85.6 x 54mm). 배경이 페이지 끝까지 채워지고,
//    재단 여백(블리드) 3mm를 켜면 페이지가 91.6 x 60mm로 커진다.
//  - 카드 안쪽 여백: 카드 가장자리에서 글자·QR까지의 거리(2~5mm).
// QR에는 상품권 페이지 주소가 들어가서 손님이 휴대폰 카메라로 찍으면 잔액 페이지가 열리고,
// 어드민 QR스캔은 주소에서 상품권 ID만 꺼내 등록·사용 처리한다.
const CARD_WIDTH_MM = 85.6;
const CARD_HEIGHT_MM = 54;
const INSET_OPTIONS_MM = [2, 3, 4, 5];
const INSET_DEFAULT_MM = 4;
const A4_PAGE_MARGIN_MM = 5;
const A4_COLUMNS = 2;
const CARDS_PER_A4 = 10;
const BLEED_MM = 3;
const GIFT_CARD_URL = "https://withanod.com/giftcard/";

class PrintGiftCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ids: this.onParseIds(),
      cards: {},
      loaded: false,
      layout: "a4", // "a4" | "card"
      sides: "front", // "front" | "both" | "back"
      insetMm: INSET_DEFAULT_MM,
      bleed: false,
    };
  }

  // 주소의 ?ids=a,b,c 에서 상품권 ID 목록을 읽는다. (shortid 문자만 허용)
  onParseIds() {
    const search = window.location.search.replace(/^\?/, "");
    let ids = "";
    search.split("&").forEach((pair) => {
      const parts = pair.split("=");
      if (parts[0] === "ids" && parts[1]) {
        ids = decodeURIComponent(parts[1]);
      }
    });
    return ids
      .split(",")
      .map((id) => id.trim())
      .filter((id) => /^[A-Za-z0-9_-]+$/.test(id));
  }

  componentDidMount() {
    const ids = this.state.ids;
    if (ids.length === 0) {
      this.setState({ loaded: true });
      return;
    }
    Promise.all(
      ids.map((id) =>
        firebase
          .database()
          .ref(`giftCards/${id}`)
          .once("value")
          .then((snapshot) => ({ id: id, card: snapshot.val() }))
          .catch(() => ({ id: id, card: null }))
      )
    ).then((results) => {
      const cards = {};
      results.forEach((result) => {
        if (result.card) {
          cards[result.id] = result.card;
        }
      });
      this.setState({ cards: cards, loaded: true });
    });
  }

  onChangeCurrencyFormat(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // 카드 1장의 크기와 안쪽 여백(mm).
  // 카드 모드에서 블리드를 켜면 카드(페이지)가 그만큼 커지고 배경이 재단선 밖까지 채워진다.
  onGetCardMetrics() {
    const bleed =
      this.state.layout === "card" && this.state.bleed ? BLEED_MM : 0;
    return {
      width: CARD_WIDTH_MM + bleed * 2,
      height: CARD_HEIGHT_MM + bleed * 2,
      padding: this.state.insetMm + bleed,
      bleed: bleed,
    };
  }

  onGetCardStyle(metrics) {
    return {
      width: `${metrics.width.toFixed(1)}mm`,
      height: `${metrics.height.toFixed(1)}mm`,
      padding: `${metrics.padding.toFixed(1)}mm`,
    };
  }

  renderFront(id, card, metrics, extraClass) {
    return (
      <div
        key={"front-" + id}
        className={"gcp-card gcp-card--front " + (extraClass || "")}
        style={this.onGetCardStyle(metrics)}
      >
        <div className="gcp-top">
          <div className="gcp-top-left">
            <span className="gcp-label">GIFT CARD</span>
            <span className="gcp-name">{card.name || "위드어나드 상품권"}</span>
          </div>
          <div className="gcp-qr-box">
            <QRCode
              value={GIFT_CARD_URL + id}
              renderAs={"svg"}
              level={"M"}
              size={96}
              bgColor={"white"}
              fgColor={"#00615c"}
              includeMargin={false}
            />
          </div>
        </div>
        <div className="gcp-middle">
          <span className="gcp-amount-label">상품권 금액</span>
          <span className="gcp-amount">
            {this.onChangeCurrencyFormat(card.amount)}원
          </span>
          <div className="gcp-footer">
            <span style={{ marginLeft: "auto" }}>withanod.com</span>
          </div>
        </div>
      </div>
    );
  }

  renderBack(id, card, metrics, extraClass) {
    return (
      <div
        key={"back-" + id}
        className={"gcp-card gcp-card--back " + (extraClass || "")}
        style={this.onGetCardStyle(metrics)}
      >
        <div className="gcp-top-left">
          <span className="gcp-label">WITH A NOD</span>
          <span className="gcp-name">상품권 이용 안내</span>
        </div>
        <ul className="gcp-notes">
          <li>매장에서 카드의 QR을 등록한 날부터 6개월간 사용할 수 있습니다.</li>
          <li>
            오프라인 매장에서 현금처럼 사용하는 상품권이며, 잔액 내에서 여러 번
            나누어 쓸 수 있습니다.
          </li>
          <li>
            앞면 QR을 휴대폰 카메라로 찍으면 남은 금액과 사용 내역을 확인할 수
            있습니다.
          </li>
        </ul>
        <div className="gcp-footer">
          <span>No. {id}</span>
          <span>withanod.com</span>
        </div>
      </div>
    );
  }

  // A4 뒷면 시트: 양면 인쇄(긴 쪽 뒤집기) 시 앞면과 맞도록 각 줄 안에서 좌우를 바꾼다.
  // 줄이 다 차지 않으면 빈 칸(null)으로 자리를 맞춘다.
  onMirrorRows(ids) {
    const mirrored = [];
    for (let i = 0; i < ids.length; i += A4_COLUMNS) {
      const row = ids.slice(i, i + A4_COLUMNS);
      while (row.length < A4_COLUMNS) {
        row.push(null);
      }
      row.reverse().forEach((id) => mirrored.push(id));
    }
    return mirrored;
  }

  renderSheet(key, ids, side, metrics) {
    return (
      <div key={key} className="gcp-sheet">
        {ids.map((id, index) => {
          if (!id) {
            return (
              <div
                key={"blank-" + index}
                className="gcp-card gcp-card--blank"
                style={this.onGetCardStyle(metrics)}
              />
            );
          }
          return side === "back"
            ? this.renderBack(id, this.state.cards[id], metrics)
            : this.renderFront(id, this.state.cards[id], metrics);
        })}
      </div>
    );
  }

  render() {
    const { ids, cards, loaded, layout, sides, insetMm, bleed } = this.state;
    const printable = ids.filter((id) => cards[id]);
    const missing = ids.length - printable.length;
    const metrics = this.onGetCardMetrics();
    const pageStyle =
      layout === "card"
        ? `@page { size: ${metrics.width.toFixed(1)}mm ${metrics.height.toFixed(
            1
          )}mm; margin: 0; }`
        : `@page { size: A4 portrait; margin: ${A4_PAGE_MARGIN_MM}mm; }`;

    const pages = [];
    if (layout === "a4") {
      for (let i = 0; i < printable.length; i += CARDS_PER_A4) {
        const sheetIds = printable.slice(i, i + CARDS_PER_A4);
        if (sides !== "back") {
          pages.push(this.renderSheet("front-" + i, sheetIds, "front", metrics));
        }
        if (sides !== "front") {
          pages.push(
            this.renderSheet(
              "back-" + i,
              this.onMirrorRows(sheetIds),
              "back",
              metrics
            )
          );
        }
      }
    } else {
      printable.forEach((id) => {
        if (sides !== "back") {
          pages.push(this.renderFront(id, cards[id], metrics, "gcp-card--page"));
        }
        if (sides !== "front") {
          pages.push(this.renderBack(id, cards[id], metrics, "gcp-card--page"));
        }
      });
    }

    let helpText =
      '인쇄 창에서 대상을 "PDF로 저장"으로 고르고, 여백은 "기본값"으로 두세요. 카드 배경색은 자동으로 인쇄됩니다.';
    if (layout === "a4") {
      helpText += ` A4 가장자리 여백은 ${A4_PAGE_MARGIN_MM}mm이고, 카드는 초록색 테두리를 따라 자르면 됩니다.`;
      if (sides === "both") {
        helpText +=
          ' 양면으로 인쇄할 때는 "양면 인쇄 - 긴 쪽 뒤집기"로 설정해야 앞뒤가 맞습니다.';
      }
    } else {
      helpText += ` 페이지 크기는 ${metrics.width.toFixed(1)} × ${metrics.height.toFixed(
        1
      )}mm이고 글자와 QR은 카드 가장자리에서 ${insetMm}mm 안쪽에 들어갑니다.`;
      helpText += bleed
        ? " 재단 여백 3mm가 포함되어 있어 인쇄업체에 그대로 전달할 수 있습니다."
        : " 인쇄업체가 재단 여백(블리드)을 요구하면 위 옵션을 켜 주세요.";
      if (sides === "both") {
        helpText += " 앞면 다음 페이지가 같은 카드의 뒷면입니다.";
      }
    }

    return (
      <div className="gcp-root">
        <style>{pageStyle}</style>
        <div className="gcp-toolbar no-print">
          <span style={{ fontWeight: "bold", fontSize: 16 }}>
            실물 상품권 인쇄
          </span>
          {!loaded ? (
            <span>상품권을 불러오는 중...</span>
          ) : (
            <React.Fragment>
              <span>
                {printable.length}장
                {missing > 0 ? ` (찾을 수 없는 상품권 ${missing}장 제외)` : ""}
              </span>
              <div className="gcp-option-group">
                <span className="gcp-option-title">용지</span>
                <label>
                  <input
                    type="radio"
                    checked={layout === "a4"}
                    onChange={() => this.setState({ layout: "a4" })}
                  />{" "}
                  A4 한 장에 10장
                </label>
                <label>
                  <input
                    type="radio"
                    checked={layout === "card"}
                    onChange={() => this.setState({ layout: "card" })}
                  />{" "}
                  카드 1장 = 1페이지 ({CARD_WIDTH_MM} × {CARD_HEIGHT_MM}mm,
                  인쇄업체용)
                </label>
              </div>
              <div className="gcp-option-group">
                <span className="gcp-option-title">면</span>
                <label>
                  <input
                    type="radio"
                    checked={sides === "front"}
                    onChange={() => this.setState({ sides: "front" })}
                  />{" "}
                  앞면만
                </label>
                <label>
                  <input
                    type="radio"
                    checked={sides === "both"}
                    onChange={() => this.setState({ sides: "both" })}
                  />{" "}
                  앞면 + 뒷면
                </label>
                <label>
                  <input
                    type="radio"
                    checked={sides === "back"}
                    onChange={() => this.setState({ sides: "back" })}
                  />{" "}
                  뒷면만
                </label>
              </div>
              <div className="gcp-option-group">
                <span className="gcp-option-title">카드 안쪽 여백</span>
                {INSET_OPTIONS_MM.map((option) => (
                  <label key={option}>
                    <input
                      type="radio"
                      checked={insetMm === option}
                      onChange={() => this.setState({ insetMm: option })}
                    />{" "}
                    {option}mm
                  </label>
                ))}
              </div>
              {layout === "card" && (
                <div className="gcp-option-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={bleed}
                      onChange={() => this.setState({ bleed: !bleed })}
                    />{" "}
                    재단 여백(블리드) {BLEED_MM}mm 포함 (페이지{" "}
                    {(CARD_WIDTH_MM + BLEED_MM * 2).toFixed(1)} ×{" "}
                    {(CARD_HEIGHT_MM + BLEED_MM * 2).toFixed(1)}mm)
                  </label>
                </div>
              )}
              <button
                type="button"
                className="gcp-button"
                onClick={() => window.print()}
                disabled={printable.length === 0}
              >
                인쇄 / PDF로 저장
              </button>
              <span className="gcp-help">{helpText}</span>
            </React.Fragment>
          )}
        </div>
        {loaded && printable.length === 0 && (
          <div className="gcp-empty">
            인쇄할 상품권이 없습니다. 어드민의 상품권 발급 내역에서 다시
            열어주세요.
          </div>
        )}
        {pages}
      </div>
    );
  }
}

export default PrintGiftCards;
